export type ServiceAreaId =
  | 'bentonville'
  | 'rogers'
  | 'benton-county'
  | 'springdale'
  | 'fayetteville'
  | 'washington-county'
  | 'arkansas'

export interface ServiceArea {
  id: ServiceAreaId
  name: string
  travelFee: number
  hourlyTravel: boolean
  displayPrice: string
  note?: string
}

export const serviceAreas: ServiceArea[] = [
  {
    id: 'bentonville',
    name: 'Bentonville',
    travelFee: 60,
    hourlyTravel: false,
    displayPrice: '$60',
  },
  {
    id: 'rogers',
    name: 'Rogers',
    travelFee: 70,
    hourlyTravel: false,
    displayPrice: '$70',
  },
  {
    id: 'benton-county',
    name: 'Surrounding Benton County cities',
    travelFee: 80,
    hourlyTravel: false,
    displayPrice: '$80',
  },
  {
    id: 'springdale',
    name: 'Springdale',
    travelFee: 100,
    hourlyTravel: false,
    displayPrice: '$100',
  },
  {
    id: 'fayetteville',
    name: 'Fayetteville',
    travelFee: 100,
    hourlyTravel: false,
    displayPrice: '$100',
  },
  {
    id: 'washington-county',
    name: 'Other Washington County cities',
    travelFee: 100,
    hourlyTravel: true,
    displayPrice: '$100 + $50/hour',
    note: 'Outside Springdale and Fayetteville. Custom travel quote required.',
  },
  {
    id: 'arkansas',
    name: 'Elsewhere in Arkansas',
    travelFee: 100,
    hourlyTravel: true,
    displayPrice: '$100 + $50/hour',
    note: 'Plus notary or service fees. Custom travel quote required.',
  },
]
